// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .table-bordered th[data-v-67180d73], [dir] td[data-v-67180d73] {\r\n  border: 1px solid #dee2e6;\n}\n.table th[data-v-67180d73] {\r\n  vertical-align: middle;\n}\r\n", ""]);
// Exports
module.exports = exports;
